// extracted by mini-css-extract-plugin
export default {"breakpointMedium":"992px","breakpointLarge":"1440px"};